import { CollectionListResourceCollections } from "@/api/generated-api";
import ArrowLink from "@/components/ui/arrow-link";
import { FC } from "react";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import Image from "next/image";

interface ICollectionCard {
  collection: CollectionListResourceCollections;
}

const CollectionCard: FC<ICollectionCard> = ({ collection }) => {
  const { title, id, description, preview_image, product_count } = collection;
  const t = useTranslations();

  const productsCount = t("productsCount", { count: product_count || 1 });

  return (
    <div className={S.card}>
      <Image className={S.cardImage} width={660} height={320} src={preview_image} alt={"collection"} />
      <div className={S.cardInfo}>
        <h3 className={S.cardTitle}>{title}</h3>
        <span className={S.cardDescription}>{description}</span>
        <div className={S.bottomBlock}>
          <div className={S.counter}>{productsCount}</div>
          <ArrowLink text={t("seeAll")} url={`/collections/${id}`} />
        </div>
      </div>
    </div>
  );
};

export default CollectionCard;
